<template lang="pug">
  bloco#localizacao.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Localização
    //- CONTENT
    .conteudo(slot="content")
      p
        | Centro da Reitoria
        br
        | Campus Universitário Lagoa Nova, CEP 59078-970 | Natal/RN - Brasil
      .mapa: iframe(:src="url" frameborder="0" allowfullscreen)
</template>

<style lang="scss">
  #localizacao {
    > .conteudo {
      > .mapa {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 100%;

        > iframe {
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }

    @include media(">=tablet","<desktop") {
      > .conteudo {
        padding: 0 2rem;
        > .mapa { padding-bottom: 60%; }
      }
    }

    @include media(">=desktop") {
      > .conteudo {
        padding: 0 2rem;
        > .mapa { padding-bottom: 70%; }
      }
    }
  }
</style>

<script>
  import Bloco from 'COMPONENTS/Bloco'
  import Titulo from 'COMPONENTS/ContentTitle'

  export default {

    components: {
      Bloco,
      Titulo
    },

    data () {
      return {
        url: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3969.1171066261413!2d-35.2006171!3d-5.8391137!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2ff9d0d533939%3A0x74e83eb2d823dfd5!2sReitoria+da+UFRN!5e0!3m2!1spt-BR!2sbr!4v1507221339638'
      }
    }

  }
</script>



// WEBPACK FOOTER //
// Localizacao.vue?5f1f7044